import { c as _c } from "react/compiler-runtime";
import Drops from "@/components/drops/view/Drops";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageDrops(t0) {
  const $ = _c(4);
  const {
    profile
  } = t0;
  const haveProfile = !!profile?.handle;
  let t1;
  if ($[0] !== haveProfile) {
    t1 = haveProfile && <Drops />;
    $[0] = haveProfile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tailwind-scope"><div className="tw-max-w-4xl tw-mx-auto tw-py-4">{t1}</div></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}